"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostPaywall = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
/**
 * mm-post-paywall
 * 글 본문이 끊기는 자리에서 뒤따르는 내용이 멤버십 전용임을 알리는 영역.
 * 바로 위 본문 끝을 배경색으로 흐려 글이 이어진다는 인상을 주고, 안내 내용은 슬롯으로 받는다.
 */
let PostPaywall = class PostPaywall extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
PostPaywall.styles = (0, lit_1.css) `
    :host {
      display: block;
      position: relative;
    }

    /* 본문 끝이 흐려지며 안내로 이어지도록 host 위쪽으로 그라데이션을 겹친다. */
    :host::before {
      content: '';
      height: 20rem;
      background: linear-gradient(
        to bottom,
        transparent,
        color-mix(in srgb, var(--background-color) 75%, transparent),
        var(--background-color)
      );
      position: absolute;
      left: 0;
      right: 0;
      bottom: 100%;
    }
  `;
PostPaywall = __decorate([
    (0, decorators_js_1.customElement)('mm-post-paywall')
], PostPaywall);
exports.PostPaywall = PostPaywall;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zdC1wYXl3YWxsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicG9zdC1wYXl3YWxsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBaUQ7QUFFakQ7Ozs7R0FJRztBQUVJLElBQU0sV0FBVyxHQUFqQixNQUFNLFdBQVksU0FBUSxnQkFBVTtJQXdCekMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O0tBRVYsQ0FBQTtJQUNILENBQUM7O0FBM0JNLGtCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQXFCbEIsQ0FBQTtBQXRCVSxXQUFXO0lBRHZCLElBQUEsNkJBQWEsRUFBQyxpQkFBaUIsQ0FBQztHQUNwQixXQUFXLENBNkJ2QjtBQTdCWSxrQ0FBVyJ9